/* tslint:disable */
/* eslint-disable */
/**
 * K1 OpenAPI
 * API fuer die Nutzung der K1 REST-Schnittstelle
 *
 * The version of the OpenAPI document: 1.168.0-SNAPSHOT
 * Contact: diplan-backend@init.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorRest } from '../models';
// @ts-ignore
import type { VerfahrenDetailRest } from '../models';
/**
 * WettbewerbsVerfahrenImportResourceWesiaApi - axios parameter creator
 * @export
 */
export const WettbewerbsVerfahrenImportResourceWesiaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden Wettbewerbe in das System importiert.<br> Die Wettbewerbe werden als Verfahren gespeichert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Importieren von Wettbewerben.
         * @param {File} file XML-Datei mit den Wettbewerben
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadXPlanverfahren1: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadXPlanverfahren1', 'file', file)
            const localVarPath = `/wettbewerbsverfahren/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WettbewerbsVerfahrenImportResourceWesiaApi - functional programming interface
 * @export
 */
export const WettbewerbsVerfahrenImportResourceWesiaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WettbewerbsVerfahrenImportResourceWesiaApiAxiosParamCreator(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden Wettbewerbe in das System importiert.<br> Die Wettbewerbe werden als Verfahren gespeichert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Importieren von Wettbewerben.
         * @param {File} file XML-Datei mit den Wettbewerben
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadXPlanverfahren1(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VerfahrenDetailRest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadXPlanverfahren1(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WettbewerbsVerfahrenImportResourceWesiaApi.uploadXPlanverfahren1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WettbewerbsVerfahrenImportResourceWesiaApi - factory interface
 * @export
 */
export const WettbewerbsVerfahrenImportResourceWesiaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WettbewerbsVerfahrenImportResourceWesiaApiFp(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden Wettbewerbe in das System importiert.<br> Die Wettbewerbe werden als Verfahren gespeichert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Importieren von Wettbewerben.
         * @param {File} file XML-Datei mit den Wettbewerben
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadXPlanverfahren1(file: File, options?: RawAxiosRequestConfig): AxiosPromise<Array<VerfahrenDetailRest>> {
            return localVarFp.uploadXPlanverfahren1(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WettbewerbsVerfahrenImportResourceWesiaApi - object-oriented interface
 * @export
 * @class WettbewerbsVerfahrenImportResourceWesiaApi
 * @extends {BaseAPI}
 */
export class WettbewerbsVerfahrenImportResourceWesiaApi extends BaseAPI {
    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden Wettbewerbe in das System importiert.<br> Die Wettbewerbe werden als Verfahren gespeichert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
     * @summary Endpunkt zum Importieren von Wettbewerben.
     * @param {File} file XML-Datei mit den Wettbewerben
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WettbewerbsVerfahrenImportResourceWesiaApi
     */
    public uploadXPlanverfahren1(file: File, options?: RawAxiosRequestConfig) {
        return WettbewerbsVerfahrenImportResourceWesiaApiFp(this.configuration).uploadXPlanverfahren1(file, options).then((request) => request(this.axios, this.basePath));
    }
}

